import { Drawer } from '@/components';
import { useProject } from '@/features/project/_hooks/project';
import { useId } from '@/hooks';
import type { FC } from 'react';
import { useProjectDetailDrawerState } from '../../_components/ProjectDrawerStateProvider';
import { AlurDanaForm } from './AlurDanaForm';

export const AlurDanaFormDrawer: FC = () => {
  const { id } = useId();
  const project = useProject(id);

  const { drawerState, setDrawerState } = useProjectDetailDrawerState();
  const alurDanaId =
    drawerState.open && drawerState.type === 'alur-dana'
      ? drawerState.alurDanaId
      : undefined;

  const initialValues = alurDanaId
    ? project.data?.indonesiaData?.alurDana?.find(
        (alurDana) => alurDana.id === alurDanaId,
      )
    : undefined;

  return (
    <Drawer
      size="large"
      open={drawerState.open && drawerState.type === 'alur-dana'}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnHidden
    >
      <AlurDanaForm
        initialValues={initialValues}
        initialIndonesiaData={project.data?.indonesiaData ?? undefined}
      />
    </Drawer>
  );
};
